// extracted by mini-css-extract-plugin
module.exports = {"dot":"Dot_dot__25kXr","small":"Dot_small__R1FoN","medium":"Dot_medium__2HESN","large":"Dot_large__2bQx5","noMargins":"Dot_noMargins__3dOpM"};